import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffReceipts = () => import('./staff/receipts')
const ViewStaffReceiptsTrashed = () => import('./staff/receiptsTrashed')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'ReceiptsErpStaffDashboard',
  receipts: 'ReceiptsErpStaffReceipts',
  receiptsTrashed: 'ReceiptsErpStaffReceiptsTrashed',
}

const router =
  [
    {
      path: '/st/receipts-erp',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Recibos',
          }          
        },
        {
          path: 'receipts',
          name: VIEWS.receipts,
          component: ViewStaffReceipts,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de recibos de clientes',
          }          
        },
        {
          path: 'receipts-trashed',
          name: VIEWS.receiptsTrashed,
          component: ViewStaffReceiptsTrashed,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Recibos pendientes de aprobación',
          }          
        },        
      ]
    },

    {
      path: '/cu/receipts-erp',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/receipts-erp',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
